import { Passenger } from './../../../models/passenger';
import { NgxRolesService } from 'ngx-permissions';
import { Client } from './../../../models/client';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Select2OptionData } from 'ng2-select2';
import * as Highcharts from 'highcharts';
import * as moment from 'moment';
import { AuthService } from '../../../services/auth.service';
import { DataTablesResponse } from './../../../models/DataTablesResponse';
import { DataTableDirective } from 'angular-datatables';
// tslint:disable-next-line:import-blacklist
import { Subject } from 'rxjs/Rx';
declare var $;

@Component({
  selector: 'app-dashboard-pro',
  templateUrl: './dashboard-pro.component.html',
  styleUrls: ['./dashboard-pro.component.css']
})

export class DashboardProComponent implements OnInit, AfterViewInit, OnDestroy {

  filter = {
    clientId: '',
    schoolId: '',
    busId: '',
    date: new Date(),
  };
  staticFilter: any;

  user: any;

  schoolsData: any[];

  busData: Array<Select2OptionData>;

  passenger: Passenger;
  passengerNotfications: any;
  passengersData: any[];
  journeyPassengerDays: any[];
  journeyPassengerTypes: any[];
  passengersOptions: Select2Options;
  passengersAjaxOptions: any;
  busesOptions: Select2Options;
  adminStatus = true;

  i = 0;
  chartData: {
    categories: any[],
    series: any[]
  };
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: {};

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;

  dtOptions1: DataTables.Settings = {};
  dtOptions2: DataTables.Settings = {};

  dtTrigger1: Subject<any> = new Subject();
  dtTrigger2: Subject<any> = new Subject();

  unservedJourneyPassengers: any[];
  busEvents: any[];

  days: {};
  hourFormat = function (num) {
    const m = moment(num, 'X');
    return m.format('HH:mm');
  };
  HMSFormat = function (num) {
    const m = moment(num, 'X');
    return m.format('HH:mm:ss');
  };
  dateTimeFilter = (d: Date): boolean => {
    return true;
  }

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private roleService: NgxRolesService
  ) {
    this.staticFilter = JSON.parse(JSON.stringify(this.filter));
    this.chartData = {
      categories: [],
      series: []
    };
    this.busEvents = [];
    this.user = this.authService.getUser();
    if (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      this.filter.clientId = this.user.id;
      this.staticFilter.clientId = this.user.id;
      this.initSchoolSelect();
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.filter.clientId = this.user.School.Client.id;
      this.filter.schoolId = this.user.School.id;
      this.staticFilter.clientId = this.user.School.Client.id;
      this.staticFilter.schoolId = this.user.School.id;
      this.adminStatus = this.user.isRespAdmin;
      this.onFilter();
    }
    this.days = {
      1: 'Lundi',
      2: 'Mardi',
      3: 'Mercredi',
      4: 'Jeudi',
      5: 'Vendredi'
    };
  }

  ngOnInit() {
    $('[data-toggle="tooltip"]').tooltip();
    this.passengersAjaxOptions = {
      url: '/api/passenger/lookup',
      dataType: 'json',
      delay: 500,
      cache: false,
      data: (params: any) => {
        return {
          search: params.term,
          gotoPage: params.page,
          schoolId: this.staticFilter.schoolId,
          busIds: this.filter.busId ? JSON.stringify([this.filter.busId]) : '',
          notSelectedPassengerIds: [],
          isAssistant: 'false',
          isActive: 'true',
          token: localStorage.getItem('token')
        };
      },
      processResults: (data: any, params: any) => {
        params.page = params.page || 1;
        return {
          results: $.map(data.rows, function (obj) {
            return { id: obj.id, text: obj.lastname };
          }),
          pagination: {
            more: (params.page * 10) < data.count
          }
        };
      },
    };
    this.passengersOptions = {
      placeholder: 'Choisir un passager',
      ajax: this.passengersAjaxOptions
    };
    this.busesOptions = {
      allowClear: true,
      placeholder: 'Choisir un bus'
    };

    this.dtOptions1 = {
      searching: false,
      pageLength: 5,
      processing: true,
      lengthMenu: [[5, 10, 25, 50, 100], [5, 10, 25, 50, 100]],
      ordering: false,
      dom: '<t> <"row" <"col-md-4"l><"col-md-8"p>>',
      language: {
        processing: 'Traitement en cours...',
        search: 'Rechercher&nbsp;:',
        lengthMenu: 'Afficher _MENU_ &eacute;l&eacute;ments',
        info: 'Affichage de l\'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments',
        infoEmpty: 'Affichage de l\'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment',
        infoFiltered: '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
        infoPostFix: '',
        loadingRecords: 'Chargement en cours...',
        zeroRecords: 'Aucun &eacute;l&eacute;ment &agrave; afficher',
        emptyTable: 'Aucune donn&eacute;e disponible dans le tableau',
        paginate: {
          first: 'Premier',
          previous: 'Pr&eacute;c&eacute;dent',
          next: 'Suivant',
          last: 'Dernier'
        },
        aria: {
          sortAscending: ': activer pour trier la colonne par ordre croissant',
          sortDescending: ': activer pour trier la colonne par ordre d&eacute;croissant'
        }
      },
    };
    this.dtOptions2 = {
      searching: false,
      pageLength: 5,
      processing: true,
      lengthMenu: [[5, 10, 25, 50, 100], [5, 10, 25, 50, 100]],
      ordering: false,
      dom: '<t> <"row" <"col-md-4"l><"col-md-8"p>>',
      language: {
        processing: 'Traitement en cours...',
        search: 'Rechercher&nbsp;:',
        lengthMenu: 'Afficher _MENU_ &eacute;l&eacute;ments',
        info: 'Affichage de l\'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments',
        infoEmpty: 'Affichage de l\'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment',
        infoFiltered: '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
        infoPostFix: '',
        loadingRecords: 'Chargement en cours...',
        zeroRecords: 'Aucun &eacute;l&eacute;ment &agrave; afficher',
        emptyTable: 'Aucune donn&eacute;e disponible dans le tableau',
        paginate: {
          first: 'Premier',
          previous: 'Pr&eacute;c&eacute;dent',
          next: 'Suivant',
          last: 'Dernier'
        },
        aria: {
          sortAscending: ': activer pour trier la colonne par ordre croissant',
          sortDescending: ': activer pour trier la colonne par ordre d&eacute;croissant'
        }
      },
    };
    this.loadHighChartsOptions();

    this.busData = [];
    this.passengersData = [];
  }

  ngAfterViewInit(): void {
    this.dtTrigger1.next();
    this.dtTrigger2.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger1.unsubscribe();
    this.dtTrigger2.unsubscribe();
  }

  initSchoolSelect() {
    this.filter.schoolId = '';
    const params = new HttpParams({
      fromObject: {
        clientId: this.staticFilter.clientId
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      this.filter.schoolId = schools.length ? schools[0].id : '';
      this.schoolsData = schools.map((school, index) => {
        return {
          id: school.id,
          text: school.name,
          selected: school.id == this.filter.schoolId ? true : false
        };
      });
      this.onFilter();
    });
  }

  initBusSelect() {
    this.filter.busId = '';
    const params = new HttpParams({
      fromObject: {
        clientId: this.staticFilter.clientId,
        schoolId: this.staticFilter.schoolId,
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      this.filter.busId = buses.length ? buses[0].id : '';
      this.busData = buses.map((bus, index) => {
        return {
          id: bus.id,
          text: bus.name,
          selected: bus.id == this.filter.busId ? true : false
        };
      });
    });
  }

  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
  }

  busChanged(e: any) {
    this.filter.busId = e.value;
    this.passenger = null;
    this.passengerNotfications = {
      am1: '--:--',
      am2: '--:--',
      pm1: '--:--',
      pm2: '--:--',
    };
  }

  passengerChanged(e: any) {
    this.passenger = null;
    this.passengerNotfications = {
      am1: '--:--',
      am2: '--:--',
      pm1: '--:--',
      pm2: '--:--',
    };
    this.passengersData = [];
    this.journeyPassengerDays = [];
    this.journeyPassengerTypes = [];
    let daysNames = [];

    if (e.value != null) {
      this.http.get(
        '/api/passenger/' + e.value
      ).subscribe((data: any) => {
        const passenger = data.passenger;
        this.passenger = passenger;

        this.passenger.JourneyPassengers.forEach( journeyPassenger => {
          // Get days where Journey existe
          daysNames = [];
          if (journeyPassenger.Journey.J_1) {
            daysNames.push('Lundi');
          }
          if (journeyPassenger.Journey.J_2) {
            daysNames.push('Mardi');
          }
          if (journeyPassenger.Journey.J_3) {
            daysNames.push('Mercredi');
          }
          if (journeyPassenger.Journey.J_4) {
            daysNames.push('Jeudi');
          }
          if (journeyPassenger.Journey.J_5) {
            daysNames.push('Vendredi');
          }
          this.journeyPassengerDays[journeyPassenger.Journey.id] = daysNames.join(", ");

          // Get type of Journey
          if (journeyPassenger.Journey.type === 'M1' || journeyPassenger.Journey.type === 'AM1') {
            this.journeyPassengerTypes[journeyPassenger.Journey.id] = 'Aller';
          } else {
            this.journeyPassengerTypes[journeyPassenger.Journey.id] = 'Retour';
          }
        });
      });
      const params = new HttpParams({
        fromObject: {
          passengerId: e.value,
          schoolId: this.staticFilter.schoolId,
          history: 'true',
          date: moment(this.staticFilter.date).format('YYYY-MM-DD')
        }
      });
      this.http.get('/api/passenger/notification', { params }).subscribe((data: any) => {
        this.passengerNotfications.am1 = (data.am1 != null) ? moment(data.am1.date).format('HH:mm') : '--:--';
        this.passengerNotfications.am2 = (data.am2 != null) ? moment(data.am2.date).format('HH:mm') : '--:--';
        this.passengerNotfications.pm1 = (data.pm1 != null) ? moment(data.pm1.date).format('HH:mm') : '--:--';
        this.passengerNotfications.pm2 = (data.pm2 != null) ? moment(data.pm2.date).format('HH:mm') : '--:--';
      });
      this.passengersData = [{ id: e.value, text: e.data[0].text, selected: true }];
    }
  }

  loadHighChartsOptions() {
    this.chartOptions = {
      chart: {
        type: 'column',
        backgroundColor: 'rgba(255, 255, 255, 0.0)'
      },
      title: {
        text: ''
      },
      xAxis: {
        min: 0,
        title: {
          text: null
        },
        categories: this.chartData.categories,
        // labels: {
        //   formatter: () => {
        //     this.i++;
        //     return this.chartData[this.i].name;
        //   }
        // },
        lineWidth: 2
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
        },
        labels: {
          formatter: function () {
            return Math.round(this.value) + '%';
          }
        },
      },
      tooltip: {
        enabled: false
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            formatter: function () {
              return Math.round(this.y) + '%';
            },
          },
        },
      },
      series: [{
        data: this.chartData.series,
        type: 'column'
      }]
    };
  }

  onFilter() {
    this.chartData = {
      categories: [],
      series: []
    };
    this.busEvents = [];
    this.staticFilter = JSON.parse(JSON.stringify(this.filter));
    const params = new HttpParams({
      fromObject: {
        schoolId: this.staticFilter.schoolId,
        date: moment(this.staticFilter.date).format('YYYY-MM-DD')
      }
    });
    this.http.get(
      '/api/school/dashboard',
      { params }
    ).subscribe((data: any) => {
      data.stopsCounts.forEach(stopsCount => {
        this.chartData.categories.push(stopsCount.name);
        const chartElt = {
          y: Math.ceil(stopsCount.passedCount / stopsCount.totalCount * 100),
          color: ''
        };
        if (chartElt.y >= 85) {
          chartElt.color = '#8BC34A';
        } else if (chartElt.y >= 70) {
          chartElt.color = '#FFEB3B';
        } else {
          chartElt.color = '#F44336';
        }
        this.chartData.series.push(chartElt);
      });
      this.dtElements.forEach((dtElement: DataTableDirective) => {
        dtElement.dtInstance.then((dtInstance: any) => {
          const tableId = dtInstance.table().node().id;
          dtInstance.clear();
          dtInstance.destroy();
          if (tableId === 'table1') {
            this.busEvents = data.busEvents;
            this.dtTrigger1.next();
          } else {
            this.unservedJourneyPassengers = data.unservedJourneyPassengers;
            //console.log(this.unservedJourneyPassengers);
            this.dtTrigger2.next();
          }
        });
      });
      this.loadHighChartsOptions();
    });
    this.initBusSelect();
    if (this.passenger) {
      // tslint:disable-next-line:no-shadowed-variable
      const params = new HttpParams({
        fromObject: {
          passengerId: this.passenger.id + '',
          schoolId: this.staticFilter.schoolId,
          history: 'true',
          date: moment(this.staticFilter.date).format('YYYY-MM-DD')
        }
      });
      this.http.get('/api/passenger/notification', { params }).subscribe((data: any) => {
        this.passengerNotfications.am1 = (data.am1 != null) ? moment(data.am1.date).format('HH:mm') : '--:--';
        this.passengerNotfications.am2 = (data.am2 != null) ? moment(data.am2.date).format('HH:mm') : '--:--';
        this.passengerNotfications.pm1 = (data.pm1 != null) ? moment(data.pm1.date).format('HH:mm') : '--:--';
        this.passengerNotfications.pm2 = (data.pm2 != null) ? moment(data.pm2.date).format('HH:mm') : '--:--';
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard-pro/dashboard-pro.component.ts